"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMaximumListCountReached = void 0;
const isMaximumListCountReached = (param)=>{
    let { maximumAllowedPersonalProductLists, personalProductListsCount, productListId } = param;
    return !productListId && personalProductListsCount >= maximumAllowedPersonalProductLists;
};
exports.isMaximumListCountReached = isMaximumListCountReached;
